<div class="container-fluid p-0">
    <div class="hpanel">
        <div class="panel-body b-r-6">
            <div class="card">
                <div class="card-header p-10-30">
                    <h6> Manage member networks for your organization</h6>
                </div>
                <div class="card-body">
                  <ng-container *ngIf="isBusinessOrEnterpriseUser; else showUpgradeMessage">
                    <app-plan-card [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>
                    <div class="row">
                        <div class="col-sm-12">
                          <app-customer-search [placeholder]="'Search by network name'"></app-customer-search>
                        </div>
                        <div class="custom-datatable col-lg-12 col-md-12 col-sm-12">
                                <!-- Empty state -->
                                <div *ngIf="(listToShow$ | async)?.length === 0" class="datatable-empty-state">
                                  <app-nodata-found
                                    [title]="['No member networks found']"
                                    [screen]="'EMPTY'"
                                    [buttonShow]="false">
                                  </app-nodata-found>
                                </div>

                                <!-- Datatable with data -->
                                <div *ngIf="(listToShow$ | async)?.length > 0">
                                <ngx-datatable  #sortTable  (sort)="onSort($event)"class="bootstrap" [rows]="listToShow$ | async" [columnMode]="'force'"
                                    [headerHeight]="40" [footerHeight]="50" [rowHeight]="'auto'" [limit]="10"
                                    [selectAllRowsOnPage]="false" (select)='onSelect($event)' [externalPaging]="true"
                                    [count]="params.total" [scrollbarH]="true" [offset]="params.page - 1"
                                    (page)="nextPage($event)">
                                    <ngx-datatable-column cellClass="colValuesync" name="Networks" [width]="200" prop="businessNetworkName">
                                      <ng-template let-row="row" ngx-datatable-cell-template>
                                        <ng-container *ngIf="role !== 'EMPLOYEE' && role !== 'ADMIN'; else plainText">

                                          <a class="listinglink" [routerLink]="['/user-management/network/details']"
                                            [queryParams]="getNetworkParams(row)"
                                            routerLinkActive="router-link-active">
                                            {{ row.businessNetworkName }}
                                          </a>
                                        </ng-container>
                                        <ng-template #plainText>
                                          {{ row.businessNetworkName }}
                                        </ng-template>
                                      </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column [width]="200" name="Owner" prop="businessnetworkOwner">
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            {{row.businessnetworkOwner}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column [canAutoResize]="true" [resizeable]="true" name="Email"
                                        prop="businessEmail" [width]="200">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            <div class="custom-cell">{{ businessEmail }}</div>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column cellClass="colValuesync" name="Role" [width]="120">
                                        <ng-template ngx-datatable-cell-template>
                                            <span>Super Admin</span>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column cellClass="colValuesync" name="Members" prop="membersCount"
                                        [width]="120">
                                    </ngx-datatable-column>
                                    <ngx-datatable-column cellClass="colValuesync" name="Created Date" prop="createdOn"
                                        [width]="120">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            <label>{{ row.createdOn | timezoneDate:'MM/dd/yyyy' }}</label>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column cellClass="colValuesync" name="Last Active" prop="modifiedOn"
                                        [width]="120">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            <label>{{ row.modifiedOn | timezoneDate:'MM/dd/yyyy' }}</label>
                                        </ng-template>
                                    </ngx-datatable-column>


                                    <ngx-datatable-column cellClass="colValuesync" name="Status" prop="status"
                                        [width]="120">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            <label
                                                [ngClass]="{'active-status-table': row.status === 'ACTIVE', 'inactive-status-table': row.status === 'INACTIVE'}"
                                                class="capitalize-first">
                                                {{ row.status}}</label>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column cellClass="colValuesync" name="Actions" prop="name" [width]="150"
                                        [canAutoResize]="true" [resizeable]="true">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            <div class="wrapper">
                                                <span class="action-items">
                                                    <ng-icon name="tablerEye" class="svg-position" (click)="openViewModal(row)"></ng-icon>
                                                </span>
                                                <span *ngIf="role !== 'EMPLOYEE'&&role!='ADMIN'"class="action-items">
                                                    <ng-icon name="tablerPencil" [routerLink]="['/user-management/network/details']"
                                                        [queryParams]="getNetworkParams(row)"
                                                        routerLinkActive="router-link-active" class="svg-position"></ng-icon>
                                                </span>
                                                <span class="action-items" style="pointer-events: none;">
                                                    <ng-icon name="tablerDots" class="svg-position"></ng-icon>
                                                </span>
                                            </div>
                                        </ng-template>
                                    </ngx-datatable-column>
                                </ngx-datatable>
                                </div>
                        </div>
                    </div>
                  </ng-container>
                  <ng-template #showUpgradeMessage>
                    <app-upgrade-message
                      [allocationCards]="allocationCards">
                    </app-upgrade-message>
                  </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
